export default __webpack_public_path__ + "static/AppQrBig-3d00478bb31c2e46b4bae8df349ba929.svg";